<template>
  <tk-flex middle>
    <v-text-field readonly :label="label" :value="url" @click.native="pick" :error-messages="error" :disabled="disabled"></v-text-field>
    <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
    <span v-else>
      <v-btn icon v-if="url" @click.native="download"><v-icon >file_download</v-icon></v-btn>
      <v-btn icon v-if="url && !disabled" class="no-margin" @click.native="clear"><v-icon >clear</v-icon></v-btn>
      <v-icon v-if="!url">attach_file</v-icon>
    </span>
  </tk-flex>
</template>
<script>
  import uuid from 'uuid/v4'
  export default {
    name: 'image-input',
    data: function () {
      return {
        loading: false,
        url: ''
      }
    },
    created () {
      this.url = this.value
    },
    watch: {
      url () {
        this.$emit('input', this.url)
      },
      value () {
        this.url = this.value
      }
    },
    computed: {
      hasError () {
        return this.error || this.typeError
      }
    },
    methods: {
      download () {
        window.location.href = this.url
      },
      clear () {
        this.url = ''
      },
      pick () {
        if (this.loading) return
        this.$tkFile.pick({
          type: '*'
        }).then((file) => {
          this.upload(file)
        })
      },
      async upload (file) {
        let fileName
        if (this.generateName && this.useParse) {
          fileName = uuid() + '.' + file.ext
        }
        this.loading = true
        if (this.useParse) {
          let url = fileName ? '/files/' + fileName : '/files/'
          let rs = await this.$tkParse.post(url, file.buffer).catch(() => {
            this.$tkGlobal.alert.show('文件上传失败')
          })
          if (rs) {
            this.url = rs.data.url
          }
        } else {
          let data = this.$tkFile.createFormData({
            file: file
          })
          let rs = await this.$apiAjax.post('/file', data).catch(e => {
            this.$tkGlobal.alert.show('文件上传失败')
          })
          if (rs) {
            this.url = rs.data.url
          }
        }
        this.loading = false
      }
    },
    props: {
      value: String,
      label: String,
      error: String,
      generateName: Boolean,
      disabled: Boolean,
      useParse: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .no-margin {
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/fileInput.vue